module.exports = __webpack_public_path__ + "static/media/UIC_Logo.0f92c8c7.png";